module.exports = __webpack_public_path__ + "assets/mstile-150x150.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/icons/mstile-150x150.png
// module id = 935
// module chunks = 17